'use client'

import { getImageUrl, sendRequest } from '@/lib/api-service';
import { Schedule } from '@/lib/interfaces';
import { formatDate, getDayCount } from '@/lib/utils';
import Link from 'next/link';
import { useState, useEffect } from 'react';
import { FaChevronRight } from 'react-icons/fa'


export default function RegisterSection() {
	const [schedules, setSchedules] = useState<Schedule[]>([]);

	useEffect(() => {
		const fetchSchedules = async () => {
			try {
				const data = await sendRequest("GET", "/schedules/");
				setSchedules(data);
			} catch (error) {
				console.error("Error fetching schedules", error);
			}
		};
		fetchSchedules();
	}, []);


	return (

		<div className='grid md:grid-cols-2 grid-cols-1 max-w-[1000px] md:gap-10 gap-5 md:mx-auto mx-5'>
			{schedules &&
				schedules.map((schedule, i) => (
					<div
						key={i}
						className={`w-full aspect-[7/3] rounded-2xl overflow-hidden relative shadow-lg group `}
						style={{ backgroundImage: `url(${schedule.thumbnail ? getImageUrl(schedule.thumbnail) : '/photos/36.jpg'})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
					>	
					<div className={`absolute inset-0 ${schedule.is_full && 'bg-black/50'}`} />
						<div className="text-2xl font-bold bg-brandsky-900 absolute top-5 left-5 text-white px-3 py-2 flex items-center justify-center rounded">
							{schedule.name}
						</div>

						{schedule.subtitle && 
						<div className="text-sm font-bold text-brand-500 absolute bottom-5 left-5 bg-white px-3 py-1 flex items-center justify-center rounded">
							{schedule.subtitle}
						</div>
						}
						
						<div className="absolute right-5 top-5 bg-white text-brandsky-900 font-bold px-3 rounded text-lg">{formatDate(schedule.start_date)} - {formatDate(schedule.end_date)}</div>
						<div className="absolute right-5 top-14 bg-white text-brandsky-900 font-bold px-3 rounded  text-lg">{getDayCount(schedule.start_date, schedule.end_date)} хоног</div>
						{schedule.max_registrants===0 &&
								<div className="absolute right-5 bottom-5 bg-gray-500 text-white px-4 font-semibold py-1 rounded flex items-center text-xl select-none">
								<div>Хаалттай</div>
							</div>
						}
						{schedule.max_registrants!==0 && schedule.is_full && 
							<div className="absolute right-5 bottom-5 bg-gray-500 text-white px-4 font-semibold py-1 rounded flex items-center text-xl select-none">
								<div>Дүүрсэн</div>
							</div>
						}
						{!schedule.is_full && 
							<Link href={`/schedule/${schedule.id}`} className="absolute right-5 bottom-5 bg-mountain-900 hover:bg-mountain-600 text-white px-4 font-semibold py-1 rounded flex items-center text-xl">
								<div>Бүртгүүлэх</div> <FaChevronRight size={14} />
							</Link>
						}
						
					</div>
				))
			}
		</div>

	)
}
